var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "main-content",
      attrs: {
        visible: _vm.innerVisible,
        title:
          _vm.$t("CargoMsg.Cargo_Size") +
          " - " +
          this.$t("CargoMsg.Cargo_Edit"),
        width: "550px",
        "append-to-body": "",
        "close-on-click-modal": false,
        "destroy-on-close": true
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "section", staticStyle: { width: "100%" } },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "100%" },
              attrs: { "label-position": "left", "label-width": "80px" }
            },
            [
              _c("div", [
                _c("span", { staticStyle: { "font-size": "16px" } }, [
                  _vm._v(_vm._s(_vm.from.text))
                ])
              ]),
              _c(
                "div",
                [
                  _c("cargo-ag-grid", {
                    ref: "dimensions",
                    staticStyle: { width: "100%", "min-width": "180px" },
                    attrs: {
                      "show-side-bar": false,
                      "grid-options": _vm.options,
                      "column-defs": _vm.column,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c("div", { staticStyle: { display: "flex" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "text-align": "left",
                  "align-items": "center",
                  "font-size": "20px",
                  width: "50%"
                }
              },
              [
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_BatchEnterDimensions")))
                ])
              ]
            ),
            _c(
              "div",
              {
                staticStyle: {
                  "text-align": "right",
                  "padding-top": "5px",
                  "padding-bottom": "5px",
                  width: "50%"
                }
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: { click: _vm.empty2Handler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { type: "default" },
                    on: { click: _vm.estimatedDeliveryHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Recognition")) + " ")]
                )
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c("el-input", {
                attrs: {
                  no: "notes",
                  type: "textarea",
                  placeholder: _vm.$t("CargoMsg.Cargo_ReadingTip"),
                  rows: 5,
                  size: "min"
                },
                model: {
                  value: _vm.from.notes,
                  callback: function($$v) {
                    _vm.$set(_vm.from, "notes", $$v)
                  },
                  expression: "from.notes"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { "text-align": "right" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.okHandler } },
            [_vm._v(_vm._s(_vm.$t("SeaExport.Confirm")))]
          ),
          _c(
            "el-button",
            { attrs: { type: "default" }, on: { click: _vm.emptyHandler } },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")))]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }